import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/Routes';
import { EventTemplate } from '../../../types/EventTemplate';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';

export const postEventTemplate = async (formData: EventTemplate) => {
  const response = await CustomAxios.post(`event_templates`, formData);
  const { data } = response;
  return data;
};

type useCreateEventTemplateProps = {
  onSuccessCallback: () => void;
};

export function useCreateEventTemplate({ onSuccessCallback }: useCreateEventTemplateProps) {
  const navigate = useNavigate();
  return useMutation({
    mutationKey: [mutationKeys.createEventTemplate],
    mutationFn: (formData: EventTemplate) => postEventTemplate(formData),
    onSuccess: (data: EventTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEventTemplates, 'new'] });

      // call success
      onSuccessCallback();

      navigate(`/${ROUTE_PATHS.EVENT_TEMPLATES}/${data.uuid}`);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const EventTemplate: EventTemplate = err.response.data as EventTemplate;
        queryClient.setQueryData([queryKeys.allEventTemplates, 'new'], EventTemplate);
      }
    },
  });
}
